"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DateTimePicker = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _materialUiPickers = require("material-ui-pickers");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styles2 = require("../TextInput/styles");

var _DateHelper = require("../Utilities/DateHelper");

var _AccessTime = _interopRequireDefault(require("@material-ui/icons/AccessTime"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _core = require("@material-ui/core");

var _Alert = _interopRequireDefault(require("../Alert"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DateTimePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DateTimePicker, _Component);

  var _super = _createSuper(DateTimePicker);

  function DateTimePicker() {
    var _this;

    (0, _classCallCheck2.default)(this, DateTimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps, prevState, snapshot) {
      if (_this.props.value !== prevProps.value) {
        _this.props.executeValidation && _this.props.executeValidation();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnChange", function (date) {
      // If regular date, set time to 00:00:00 so we check the full day in validations.
      if (date && _this.props.pickerType === "date") {
        date.setHours(0, 0, 0, 0);
      }

      _this.props.onChange({
        target: {
          value: date
        }
      }, date);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnBlur", function (event) {
      var date = new Date(event.target.value);

      if (date) {
        var formattedDate = (0, _DateHelper.formatDate)(date, _this.props.format);
        var parsedDate = (0, _DateHelper.parseDate)(formattedDate, _this.props.format);

        if (parsedDate) {
          _this.props.onChange(event, parsedDate);

          return;
        }
      }

      _this.props.onChange({
        target: {
          value: null
        }
      }, null); // Need to execute validation here to check if the field is required after
      // leaving focus and it wasn't filled out.


      if (_this.props.required && _this.props.value == null) {
        _this.props.executeValidation && _this.props.executeValidation();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnFocus", function (event) {
      var value = event.target.value;

      if (value && (0, _DateHelper.parseDate)(value, _this.props.format) === undefined) {
        // When an invalid date is set as value, the date picker cannot be edited by keyboard.
        // This clears the value (setting to null), so that the user can type again.
        _this.props.onChange({
          target: {
            value: null
          }
        }, null);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          disableFuture = _this$props.disableFuture,
          disabled = _this$props.disabled,
          disablePast = _this$props.disablePast,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          format = _this$props.format,
          helperText = _this$props.helperText,
          id = _this$props.id,
          initialFocusedDate = _this$props.initialFocusedDate,
          keyboard = _this$props.keyboard,
          label = _this$props.label,
          locale = _this$props.locale,
          maxValue = _this$props.maxValue,
          minValue = _this$props.minValue,
          onBlur = _this$props.onBlur,
          placeholder = _this$props.placeholder,
          pickerType = _this$props.pickerType,
          displayType = _this$props.displayType,
          required = _this$props.required,
          value = _this$props.value,
          variant = _this$props.variant,
          labelProps = _this$props.labelProps,
          inputComponent = _this$props.inputComponent,
          inputProps = _this$props.inputProps,
          classes = _this$props.classes,
          fullWidth = _this$props.fullWidth,
          hideCalendarHeader = _this$props.hideCalendarHeader;
      var valueOrNull = value || null;
      var invalidLabelToString = value instanceof Date || (0, _typeof2.default)(value) === "object" ? (0, _DateHelper.formatDate)(value, format) : value;

      var renderedErrorMessage = /*#__PURE__*/_react.default.createElement("strong", {
        className: classes.errorMessageWrapper
      }, /*#__PURE__*/_react.default.createElement(_Error.default, {
        className: classes.errorIcon
      }), /*#__PURE__*/_react.default.createElement("span", null, errorMessage));

      var messageText = error && errorMessage ? renderedErrorMessage : helperText;

      var appliedLabelProps = _objectSpread(_objectSpread({
        className: (0, _classnames.default)("prmbl-textInput-label", classes[variant + "Label"]),
        classes: {
          shrink: classes[variant + "ShrunkLabel"]
        }
      }, labelProps), {}, {
        id: "".concat(id, "-label")
      });

      var appliedInputProps = {
        inputComponent: inputComponent,
        inputProps: inputProps,
        inputRef: function inputRef(el) {
          return _this.input = el;
        },
        className: (0, _classnames.default)("prmbl-textInput-input", classes[variant + "Input"])
      };
      if (pickerType === "dateTime" && displayType === "static") console.warn("The static format for dateTime is not support on DateTimePicker");
      return /*#__PURE__*/_react.default.createElement(_materialUiPickers.MuiPickersUtilsProvider, {
        utils: _dateFns.default,
        locale: locale
      }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pickerType === "dateTime" && (displayType === "dialog" ? /*#__PURE__*/_react.default.createElement(_materialUiPickers.DateTimePicker, {
        variant: variant,
        id: id,
        minDate: minValue,
        maxDate: maxValue,
        value: valueOrNull,
        onChange: _this.handleOnChange,
        onBlurCapture: onBlur,
        keyboard: keyboard,
        format: format,
        label: label,
        initialFocusedDate: initialFocusedDate,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        onBlur: _this.handleOnBlur,
        onFocus: _this.handleOnFocus,
        invalidLabel: invalidLabelToString,
        clearable: true,
        className: (0, _classnames.default)("prmbl-dateTimePicker", className, classes[variant + "Wrapper"]),
        error: error,
        FormHelperTextProps: {
          classes: {
            error: classes.error
          }
        },
        helperText: messageText,
        disableFuture: disableFuture,
        disablePast: disablePast,
        InputLabelProps: appliedLabelProps,
        InputProps: appliedInputProps,
        fullWidth: fullWidth,
        KeyboardButtonProps: {
          "aria-label": "Choose a date and time".concat(label ? " for " + label : "")
        }
      }) : displayType === "inline" ? /*#__PURE__*/_react.default.createElement(_materialUiPickers.InlineDateTimePicker, {
        variant: variant,
        id: id,
        minDate: minValue,
        maxDate: maxValue,
        value: valueOrNull,
        onChange: _this.handleOnChange,
        onBlurCapture: onBlur,
        keyboard: keyboard,
        format: format,
        label: label,
        initialFocusedDate: initialFocusedDate,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        onBlur: _this.handleOnBlur,
        onFocus: _this.handleOnFocus,
        invalidLabel: invalidLabelToString,
        clearable: true,
        className: (0, _classnames.default)("prmbl-inline-dateTimePicker", className, classes[variant + "Wrapper"]),
        error: error,
        FormHelperTextProps: {
          classes: {
            error: classes.error
          }
        },
        helperText: messageText,
        disableFuture: disableFuture,
        disablePast: disablePast,
        InputLabelProps: appliedLabelProps,
        InputProps: appliedInputProps,
        fullWidth: fullWidth,
        KeyboardButtonProps: {
          "aria-label": "Choose a date and time".concat(label ? " for " + label : "")
        }
      }) : displayType === "static" && /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_Alert.default, {
        id: "message-error",
        severity: "error"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "This view is invalid"), " \u2014 The static format for the dateTime is not supported yet."))), pickerType === "date" && (displayType === "dialog" ? /*#__PURE__*/_react.default.createElement(_materialUiPickers.DatePicker, {
        variant: variant,
        id: id,
        minDate: minValue,
        maxDate: maxValue,
        value: valueOrNull,
        onChange: _this.handleOnChange,
        onBlurCapture: onBlur,
        keyboard: keyboard,
        format: format,
        label: label,
        initialFocusedDate: initialFocusedDate,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        onBlur: _this.handleOnBlur,
        onFocus: _this.handleOnFocus,
        invalidLabel: invalidLabelToString,
        clearable: true,
        className: (0, _classnames.default)("prmbl-datePicker", className, classes[variant + "Wrapper"]),
        error: error,
        FormHelperTextProps: {
          classes: {
            error: classes.error
          }
        },
        helperText: messageText,
        disableFuture: disableFuture,
        disablePast: disablePast,
        InputLabelProps: appliedLabelProps,
        InputProps: appliedInputProps,
        fullWidth: fullWidth,
        KeyboardButtonProps: {
          "aria-label": "Choose a date".concat(label ? " for " + label : "")
        }
      }) : displayType === "inline" ? /*#__PURE__*/_react.default.createElement(_materialUiPickers.InlineDatePicker, {
        variant: variant,
        id: id,
        minDate: minValue,
        maxDate: maxValue,
        value: valueOrNull,
        onChange: _this.handleOnChange,
        onBlurCapture: onBlur,
        keyboard: keyboard,
        format: format,
        label: label,
        initialFocusedDate: initialFocusedDate,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        onBlur: _this.handleOnBlur,
        onFocus: _this.handleOnFocus,
        invalidLabel: invalidLabelToString,
        clearable: true,
        className: (0, _classnames.default)("prmbl-inline-datePicker", className, classes[variant + "Wrapper"]),
        error: error,
        FormHelperTextProps: {
          classes: {
            error: classes.error
          }
        },
        helperText: messageText,
        disableFuture: disableFuture,
        disablePast: disablePast,
        InputLabelProps: appliedLabelProps,
        InputProps: appliedInputProps,
        fullWidth: fullWidth,
        onlyCalendar: hideCalendarHeader,
        KeyboardButtonProps: {
          "aria-label": "Choose a date".concat(label ? " for " + label : "")
        }
      }) : displayType === "static" && /*#__PURE__*/_react.default.createElement(_materialUiPickers.BasePicker, {
        value: valueOrNull,
        onChange: _this.handleOnChange
      }, function (_ref) {
        var date = _ref.date,
            handleChange = _ref.handleChange;
        return /*#__PURE__*/_react.default.createElement(_core.Box, {
          className: (0, _classnames.default)("prmbl-static-datePicker-container", classes.datePickerWrapper)
        }, /*#__PURE__*/_react.default.createElement(_materialUiPickers.Calendar, {
          date: date,
          minDate: minValue,
          maxDate: maxValue,
          onChange: handleChange,
          disableFuture: disableFuture,
          disablePast: disablePast,
          id: id,
          className: (0, _classnames.default)("prmbl-static-datePicker", className)
        }));
      })), pickerType === "time" && (displayType === "dialog" ? /*#__PURE__*/_react.default.createElement(_materialUiPickers.TimePicker, {
        variant: variant,
        id: id,
        minDate: minValue,
        maxDate: maxValue,
        value: valueOrNull,
        onChange: _this.handleOnChange,
        onBlurCapture: onBlur,
        keyboard: keyboard,
        keyboardIcon: /*#__PURE__*/_react.default.createElement(_AccessTime.default, null),
        format: format,
        label: label,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        onBlur: _this.handleOnBlur,
        onFocus: _this.handleOnFocus,
        invalidLabel: invalidLabelToString,
        clearable: true,
        className: (0, _classnames.default)("prmbl-timePicker", className, classes[variant + "Wrapper"]),
        error: error,
        FormHelperTextProps: {
          classes: {
            error: classes.error
          }
        },
        helperText: messageText,
        disableFuture: disableFuture,
        disablePast: disablePast,
        InputLabelProps: appliedLabelProps,
        InputProps: appliedInputProps,
        fullWidth: fullWidth,
        KeyboardButtonProps: {
          "aria-label": "Choose a time".concat(label ? " for " + label : "")
        }
      }) : displayType === "inline" ? /*#__PURE__*/_react.default.createElement(_materialUiPickers.InlineTimePicker, {
        variant: variant,
        id: id,
        value: valueOrNull,
        onChange: _this.handleOnChange,
        onBlurCapture: onBlur,
        keyboard: keyboard,
        keyboardIcon: /*#__PURE__*/_react.default.createElement(_AccessTime.default, null),
        format: format,
        label: label,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        onBlur: _this.handleOnBlur,
        onFocus: _this.handleOnFocus,
        invalidLabel: invalidLabelToString,
        clearable: true,
        className: (0, _classnames.default)("prmbl-inline-timePicker", className, classes[variant + "Wrapper"]),
        error: error,
        FormHelperTextProps: {
          classes: {
            error: classes.error
          }
        },
        helperText: messageText,
        InputLabelProps: appliedLabelProps,
        InputProps: appliedInputProps,
        fullWidth: fullWidth,
        KeyboardButtonProps: {
          "aria-label": "Choose a time".concat(label ? " for " + label : "")
        }
      }) : displayType === "static" && /*#__PURE__*/_react.default.createElement(_materialUiPickers.BasePicker, {
        value: valueOrNull,
        onChange: _this.handleOnChange
      }, function (_ref2) {
        var date = _ref2.date,
            handleChange = _ref2.handleChange;
        return /*#__PURE__*/_react.default.createElement(_core.Box, {
          className: (0, _classnames.default)("prmbl-static-timePicker-container", classes.timePickerWrapper)
        }, /*#__PURE__*/_react.default.createElement(_materialUiPickers.TimePickerView, {
          type: "hours",
          date: date,
          onHourChange: handleChange,
          id: id,
          className: (0, _classnames.default)("prmbl-static-timePicker", className)
        }));
      }))));
    });
    return _this;
  }

  return DateTimePicker;
}(_react.Component);

(0, _defineProperty2.default)(DateTimePicker, "propTypes", {
  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * If `true` future dates are disabled.
   */
  disableFuture: _propTypes.default.bool,

  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true` past dates are disabled.
   */
  disablePast: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * The format in which the date will be displayed
   */
  format: _propTypes.default.string,

  /**
   * Helper text to be displayed for the component
   */
  helperText: _propTypes.default.node,

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * When set, this will be the initial month shown when the DateTimePicker is clicked.
   * The `Date()` function can be used. Use `{new Date()}` to select the current month.
   */
  initialFocusedDate: _propTypes.default.instanceOf(Date),

  /**
   * The component used for the native input. Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Set to true to allow keyboard input. The picker opens on click of an added icon to the text field.
   */
  keyboard: _propTypes.default.bool,

  /**
   * Set to true to show only the calendar view without the header. It's only applied to inline mode.
   */
  hideCalendarHeader: _propTypes.default.bool,

  /**
   * Sets the label for the component
   */
  label: _propTypes.default.node,

  /**
   * Additional props for the label
   */
  labelProps: _propTypes.default.shape({
    shrink: _propTypes.default.bool
  }),

  /**
   * The locale to use when formating dates.
   * Default is en-us locale. To set a different locale, import the locale object from date-fns.
   * Example: import dateFnsItLocale from "date-fns/locale/it";
   */
  locale: _propTypes.default.object,

  /**
   * Callback when the date is changed in the DateTimePicker
   *
   * Signature: `function(date, event) => void`
   *
   * event: The orginating event of the callback
   * date: The parsed date selected
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * Callback to be called when the user switches focus from the input
   *
   * function(event: object) => void
   * event: The orginating event of the callback
   */
  onBlur: _propTypes.default.func,

  /**
   * Function passed in from /Validation/index.js.. Used to bypass the checks inside index.js and call validation directly.
   */
  executeValidation: _propTypes.default.func,

  /**
   * Placeholder text to be displayed with the component
   */
  placeholder: _propTypes.default.string,

  /**
   * Set a desired end date for the Date. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select future dates.
   */
  maxValue: _propTypes.default.instanceOf(Date),

  /**
   * Set a desired start-date for the DateTimePicker. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select past dates.
   */
  minValue: _propTypes.default.instanceOf(Date),

  /**
   * The type of picker. One of "date", "time" or "dateTime"
   */
  pickerType: _propTypes.default.oneOf(["dateTime", "date", "time"]),

  /**
   * To control how display the picker element. One of "dialog", "static" or "inline"
   */
  displayType: _propTypes.default.oneOf(["dialog", "static", "inline"]),

  /**
   * When `true`, indicates that the component is required
   */
  required: _propTypes.default.bool,

  /**
   * The value of the Date Picker
   */
  value: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]),

  /**
   * How the input field for the picker appears on page.
   */
  variant: _propTypes.default.oneOf(["standard", "outlined", "filled"]),

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Makes the input span the entire component's width
   */
  fullWidth: _propTypes.default.bool
});
(0, _defineProperty2.default)(DateTimePicker, "defaultProps", {
  format: "M/d/yyyy",
  pickerType: "date",
  className: "",
  variant: "outlined",
  keyboard: true
});
var dateTimePickerWithStyles = (0, _styles.withStyles)(_styles2.styles)(DateTimePicker);
exports.DateTimePicker = dateTimePickerWithStyles;
dateTimePickerWithStyles.defaultProps = {
  format: "M/d/yyyy",
  pickerType: "date",
  displayType: "dialog",
  className: "",
  variant: "outlined"
};
// Export styled version with name "DateTimePicker"
var _default = dateTimePickerWithStyles; // Keep existing default export working

exports.default = _default;